import React, { Component } from "react";

export default class CalculateEarnedLeavesWarningDialog extends Component {
  render() {
    return (
      <div className="col-sm-12 mt20">
        <div
          className="bg-primary"
          style={{ padding: "10px", marginBottom: "40px", marginTop: "10px" }}
        >
          <p style={{ fontSize: "20px", fontWeight: "bold" }}>
            Calculate Earned Leaves Carry Balance
          </p>
        </div>
        <div style={{ paddingLeft: "20px", paddingRight: "20px" }}>
          <h2>Outstanding earned leaves remaining!</h2>
          <h3>
            The system cannot perform the earned leave carry calculation because
            there are outstanding earned leaves remaining. Please resolve the
            outstanding earned leaves before proceeding with the calculation.
          </h3>
        </div>

        <div
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            marginTop: "50px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <button
            type="button"
            className={"btn btn-primary"}
            style={{
              width: "150px",
              backgroundColor: "grey",
              color: "white",
            }}
            onClick={this.props.hideDialog}
          >
            Okay
          </button>
        </div>
      </div>
    );
  }
}
